// extracted by mini-css-extract-plugin
export default {"howInfo":"HowInfo_howInfo__WEswM","instructions":"HowInfo_instructions__qxpFH","listHeader":"HowInfo_listHeader__SKRIH","listItem":"HowInfo_listItem__ukEuD"};